export default {
  GetQiNiuToken: 'Common/QiNiu.GetToken'
}